/**
 * Franchise Xero Configuration Report
 *
 * Xero accounting configuration for all franchise partners.
 */
import BaseReportPage, { ColumnDef } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code', type: 'text' },
  { key: 'franchise_name', label: 'Franchise Name', type: 'text' },
  { key: 'last_sync_at', label: 'Data Age', type: 'sync_status' },
  { key: 'fp_status', label: 'Status' },
  { key: 'country', label: 'Country', type: 'text' },
  { key: 'xero_connected', label: 'Xero Connected', type: 'boolean' },
  { key: 'xero_short_code', label: 'Short Code', type: 'text' },
  { key: 'xero_org_name', label: 'Organisation', type: 'text' },
  { key: 'sales_tax_basis', label: 'Tax Basis', type: 'text' },
  { key: 'sales_tax_period', label: 'Tax Period', type: 'text' },
  { key: 'eoy_lock_date', label: 'EOY Lock Date', type: 'date' },
]

export default function FranchiseXeroConfigReport() {
  return (
    <BaseReportPage
      reportType="franchise_xero_config"
      title="Franchise Xero Configuration"
      description="Xero accounting configuration for all franchise partners."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        linkFpStatusToSearch: true,
      }}
      columns={columns}
      defaultSortColumn="fp_code"
      enableBulkActions
    />
  )
}
